import React, { FC } from 'react'
import { Component } from '../../types/ContentStructure'
import { Box, Card, CardContent, CardMedia, IconButton, Link, Typography } from '@mui/material'
import { East } from '@mui/icons-material'

interface IComponentFormProps {
    component: Component
}
const ComponentExternalNews: FC<IComponentFormProps> = ({ component }) => {
    const { theme, title, text, link, icon, subTitle } = component;
    return (
        <Card key={component.id} sx={[
            theme.themeStyles,
            {
                borderRadius: 15,
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: theme.themeStyles?.backgroundColor || '#00041E',
                textAlign: 'left',
                textWrap: 'pretty',
                aspectRatio: { xs: '1/1', md: '1/1' },
                height: { xs: '80vw', sm: '60vw', md: '35vh', lg: '40vh' }
            }
        ]}>
            <CardContent sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2,
                p: { xs: 2, sm: 3 }
            }}>
                <CardMedia
                    component="img"
                    sx={[component.theme.themeStyles, {
                        height: '50px',
                        backgroundColor: 'transparent',
                        userSelect: 'none',
                        objectFit: 'contain',
                        aspectRatio: '1/3',
                        objectPosition: 'left',
                    }]}
                    image={icon ?? undefined}
                    alt={title} />
                {/* Flecha en la esquina superior derecha */}
                <Link href={link} target={'_blank'} rel="noopener noreferrer">
                    <IconButton
                        sx={{
                            color: "white",
                            width: '50px',
                            height: '50px',
                            "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
                        }}
                    >
                        <East fontSize="large" />
                    </IconButton>
                </Link>
            </CardContent>
            <CardContent sx={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                px: 3,
                "&:last-child": { pb: 3 }
            }}>
                <Typography variant="h3" component="div" sx={{ fontWeight: 700, fontSize: "1.5rem", mb: 1 }}>
                    {title}
                </Typography>
                {subTitle && (
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 2, opacity: 0.9, fontSize: "0.9rem" }}>
                        {subTitle}
                    </Typography>
                )}
                <Typography variant="body2" sx={{
                    flexGrow: 1, lineHeight: 1.5, opacity: 0.85, fontSize: "0.85rem",
                    overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical', textOverflow: 'ellipsis', maxHeight: '4.5em'
                }}>
                    {text}
                </Typography>
                {text && (
                    <Typography
                        component={Link}
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="body2"
                        sx={{ pt: 1, color: 'white', fontSize: "0.85rem", fontWeight: 'bold' }}
                    >
                        Mostrar más
                    </Typography>
                )}
            </CardContent>
        </Card>
    )
}

export default ComponentExternalNews
